import {createActions, createAction, handleActions, combineActions} from 'redux-actions'
import * as url from 'constants/Api'
import log from 'components/utils/Logger';

export const statusEnum = {
    REQUEST: "REQUEST",
    SUCCESS: "SUCCESS",
    FAILURE: "FAILURE",
    ERROR: "ERROR"
};


export const http = createActions({
    CONNECTION: {
        MAP_STATUS: {
            GET: [
                () => ({method: "get", api: `${url.API_MAP_STATUS}`}),
                () => ({fetch: true, status: statusEnum.REQUEST})
            ],
        }
    }
});


export const data = createActions({
    FAILURE: [
        (data) => data,
        (data,bool) => ({isShow: bool})
    ],
    SUCCESS: [
        (data) => data,
        (data,bool) => ({isShow: bool})
    ],
    MAP_STATUS: data => data,
    MAP_LABELS : data => data,
    STOCK_STATUS: data => data
});


// WEBPACK FOOTER //
// ./src/redux/actions.js